<script setup>
import {computed, onMounted, ref, watch, onUpdated, getCurrentInstance} from 'vue'
import Options from "./Templates/Options.vue";
import ImagePreview from "./ImagePreview.vue";
import {RouterLink} from "vue-router";
import options from "./Templates/Options.vue";
import { useI18n } from '../i18n';

const instance = getCurrentInstance();
const data = ref({});
const datas = ref([]);
const showImagePreview = ref(false);
const vorschau = ref(false);
const toggle = ref([]);
const price = ref();
const itemCount = ref();
const compare_price = ref();
const percent = ref();
const product = ref([]);
const quantity = ref([]);
const productSize = ref([]);
const step = ref(1);
const { t, locale } = useI18n();
const numberLocale = computed(() => {
  if (locale?.value === 'en' || locale === 'en') return 'en-US';
  if (locale?.value === 'fr' || locale === 'fr') return 'fr-FR';
  return 'de-DE';
});
const dateObj = new Date();
const currentDate = dateObj.getFullYear() + "-" + ("0" + (dateObj.getMonth() + 1)).slice(-2) + "-" + ("0" + dateObj.getDate()).slice(-2) + " " + ("0" + dateObj.getHours()).slice(-2) + ":" + ("0" + dateObj.getMinutes()).slice(-2);
// const currentDate =  '2024-11-24 16:44';
// BLACK DEAL Zeitraum
const blackDealStart = "2024-11-24 10:00";
const blackDealEnd = "2024-12-01 23:59";

// Black Week SKUs - Items with these SKUs get BLACK DEAL badge
const BlackWeekSKUs = [
  'PDP013',
  'PDP008',
  'PDP004',
  'PDP010',
  'PMNZ004-K-36',
  'PMNZ005-K-36',
];

// CYBER DEAL Zeitraum
const cyberDealStart = "2024-12-02 08:00";
const cyberDealEnd = "2024-12-08 23:59";

// const activeTab = ref();
const props = defineProps({
  srcbild: {type: String, required: true},
  option: {type: Object},
  routeinfo: {type: Object},
  type: {type: Number}
});
const products = ref([]);
const cropNew = ref(null);
const serverFile = ref();
const activeTab = instance.appContext.config.globalProperties.$tabactive;

if (props.type == 8341420540169) {
  activeTab.value = " Eigenes Bild";
  products.value = [
    "https://picmondoo.de/products/diamond-painting-eigenes-bild-oder-foto.json",
    "https://picmondoo.de/products/diamond-painting-eigenes-bild-oder-foto.json"
  ]
} else {
  activeTab.value = " Eigenes Bild";
  products.value = [
    "https://picmondoo.de/products/malen-nach-zahlen-eigenes-bild.json"
  ]
}

// a computed ref
function itemLength() {
  return data.value.options.length;
}

function optionLength() {
  return Object.keys(props.option).length;
}

(products.value).forEach((productUrl, index) => {

  fetch(productUrl, {
    method: 'GET' //optional
  })
      .then(async (response) => {
        response = await response.json();
        const split = (response.product.title).split('-');
        response.product.title = split[1];

        // (datas.value).push(response.product);
        datas.value[index] = response.product;
        instance.appContext.config.globalProperties.$producttype = 'default';

        if (props.type == 8341420540169) {
          if (index == 0) {
            let formats = filterFormat(datas.value[index]['options'][0]['values'], 'quer');
            datas.value[index]['options'][0]['values'] = formats;
            data.value = datas.value[index];
            props.option['Größe'] = formats[0];
            props.option['Steinform'] = (data.value).variants[0]['option2'];
            generatePrice(data.value, props.option)

          }

          if (index == 1) {
            datas.value[index]['title'] = 'Quadratisch';

            let formats = filterFormat(datas.value[index]['options'][0]['values'], 'quadratisch');
            datas.value[index]['options'][0]['values'] = formats;
            // data.value = datas.value[index];
          }
        } else {
          let formats = filterFormat(datas.value[index]['options'][0]['values'], 'quer');
          data.value = datas.value[index];
          props.option['Größe'] = formats[0];
          props.option['Rahmen'] = (data.value).variants[0]['option2'];
          props.option['Farbe'] = (data.value).variants[0]['option3'];
          generatePrice(data.value, props.option)
        }


      })
      .catch((error) => {
        return error
      })

  // itemCount.value = itemLength();
});
watch(props, (newQuestion, oldQuestion) => {
  if (props.routeinfo.name === 'wandansicht') {

    let navBar = document.querySelector(".navBar");
    let mainWrapper = document.querySelector(".mainWrapper");

    if (navBar.classList.contains('open') && mainWrapper.classList.contains('open') == false) {
      mainWrapper.classList.add('open')
    }
  }
  if (props.routeinfo.name === 'wandbild') {
    getImageSizeToRoom(props.option);
  }

});

onUpdated(() => {

  let optionGroeße = document.querySelector('input[title="' + props.option['Größe'] + '"][name="Größe"]')
  let optionGSteinform = document.querySelector('input[title="' + props.option['Steinform'] + '"][name="Steinform"]')

  if (optionGroeße) {
    optionGroeße.checked = true;
  }

  if (optionGSteinform) {
    optionGSteinform.checked = true;
  }

  if (window.history && window.history.pushState) {
    if (window.history.state.forward) {
      step.value = 1;
    }
  }
});


watch(step, (newStep, oldStep) => {
  let addSteps = document.querySelector('.mainWrapper');
  if (newStep === 1) {
    addSteps.classList.remove('stepView');
    if (props.routeinfo.name === 'wandbild') {
      addSteps.classList.add('wandbildMain');
    }
  }

  if (newStep > 1) {
    addSteps.classList.add('stepView');
    // addSteps.classList.remove('wandbildMain');
  }
});

function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[arr.length - 1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {type: mime});
}

function filterFormat(formats, typ) {
  let newFormats = [];
  formats.forEach((format, index) => {
    let splitFormat = format.split("x");
    if (typ !== 'quer') {
      if (splitFormat[0] === splitFormat[1].slice(0, -2)) {
        newFormats.push(format);
      }
    } else {
      if (splitFormat[0] !== splitFormat[1].slice(0, -2)) {
        newFormats.push(format);
      }
    }

  })
  return newFormats;
}

async function uploadNew() {
  let test = instance.appContext.config.globalProperties.$cropimage.value;

  test.toBlob((blob) => {

    const formData = new FormData();

    // Pass the image file name as the third parameter if necessary.
    formData.append('croppedImage', blob/*, 'example.png' */);

    // Use `jQuery.ajax` method for example
    fetch(`${import.meta.env.VITE_API_URL}/upload.php`, {
      method: 'POST',
      data: formData,
      processData: false,
      contentType: 'multipart/form-data', // Expliziter Content-Type
      success() {
        console.log('Upload success');
      },
      error() {
        console.log('Upload error');
      },
    });
  }/*, 'image/png' */);
}

async function upload(extras = false, extraQuantity, redirect = false) {
  const canvas = document.querySelector('.preview-area img.croppedImage').src;
  let blob = dataURLToBlob(canvas);

  const formData = new FormData();
  formData.append('croppedImage', blob);

  try {
    const response = await fetch(`${import.meta.env.VITE_API_URL}/upload.php`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error('Network response was not ok.');
    }

    const serverResponse = await response.json();

    if (serverResponse?.error) {
      throw new Error('Upload-Fehler: Es ist ein Fehler aufgetreten.');
    }

    let items = [];
    let properties = [];
    (product.value).forEach((element, index) => {
      if (element) {
        if (index === 0) {
          properties = {
            'imageurl': 'https://picmondoo-image-handler.berkearas.de/uploads/' + serverResponse.fileName
          };
        }

        items[index] = {
          quantity: 1,
          id: element,
          properties: properties
        };
      }
    });

    (extras).forEach((extra, index) => {

      if (extra?.geschenk) {
        items[items.length] = {
          quantity: 1,
          id: extra?.geschenk,
          properties: properties
        };
      }
      (extra).forEach((addOnId, key) => {
        items[items.length] = {
          quantity: extraQuantity[addOnId] ?? 1,
          id: addOnId,
          properties: properties
        };
      })
    })

    console.log(items);

    let formDataCart = {
      'items': items
    };

    console.log(formDataCart);

    fetch('https://picmondoo.de/cart/add.js', {
      method: 'POST',
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(formDataCart),
      mode: 'cors'
    })
    .then(response => {
      const res = response.json();

      console.log('AddToCart Response:', res);

      if (redirect) {
        setTimeout(() => {
          location.href = 'https://www.picmondoo.de';
        }, 1000);
      }

      return res;

    })
    .catch((error) => {
      console.error('Error:', error);
      throw error;
    });





  } catch (error) {
    console.error('Fehler beim Hochladen des Bildes:', error);
    throw error;
  }
}


const dataURLToBlob = (dataURL) => {
  const binaryString = window.atob(dataURL.split(',')[1]);
  const arrayBuffer = new ArrayBuffer(binaryString.length);
  const uintArray = new Uint8Array(arrayBuffer);

  for (let i = 0; i < binaryString.length; i++) {
    uintArray[i] = binaryString.charCodeAt(i);
  }

  return new Blob([uintArray], {type: 'image/jpeg'}); // oder 'image/png' je nach Bedarf
};

async function cart(extras = false, qtyExtra = false) {
  try {
    await upload(extras, qtyExtra, true);
  } catch (error) {
    alert(t('uploadError'));
    location.href = 'https://picmondoo.de/pages/dein-eigenes-foto?v=8341420540169';
  }

}

async function cartandrestart(extras = false, qtyExtra = false) {
  try {
    await upload(extras, qtyExtra);
    if (props.type == 8341420540169) {
      location.href = 'https://picmondoo.de/pages/dein-eigenes-foto?v=8341420540169';
    } else {
      location.href = 'https://picmondoo.de/pages/dein-eigenes-foto';
    }
  } catch (error) {
    alert(t('uploadErrorRetry'))
  }
}


function nextStep() {
  step.value = step.value + 1;

  if (props.type !== '8341420540169') {
    step.value = 3
  }

}

function stepBack() {

  let navBar = document.querySelector(".navBar");
  let mainWrapper = document.querySelector(".mainWrapper");

  if (props.routeinfo.name == 'wandansicht') {
    mainWrapper.classList.add('wandbildMain');
  }

  navBar.classList.remove('open');
  mainWrapper.classList.remove('open');

  if (props.type !== '8341420540169') {
    step.value = 1;
    return;
  }

  step.value = step.value - 1;

}

function generatePrice(data, option) {

  let varianten = data.variants;
  return varianten.filter(function (variant) {
    if (variant.title == option['Größe'] + ' / ' + option['Steinform'] || variant.title == option['Größe'] + ' / ' + option['Rahmen'] + ' / ' + option['Farbe']) {
      price.value = formatPrice(variant.price);
      var pricetest = variant.price;
      compare_price.value = formatPrice(variant.compare_at_price);
      var compare_pricetest = variant.compare_at_price
      percent.value = 100 - ((100 / compare_pricetest) * pricetest);
      percent.value = (percent.value).toFixed(0)
      product.value[0] = variant.id
      productSize.value = variant.option1
    }
  })
}

function getProduktTitle(titel) {
  switch (titel) {
    case ' Eigenes Bild':
      return t('landscapePortrait');
    case ' Eigenes Bild  XXL / 3':
      return t('triptych');
    case ' Eigenes Bild XXL / 5':
      return t('fivePart');
    case 'Quadratisch':
      return t('squareFormat');
    default:
      return titel;
  }
}

function getTitel(titel) {
  switch (titel) {
    case ' Eigenes Bild':
      if (props.type !== '8341420540169') {
        return t('paintByNumbers') + ' ' + splitCm(props.option['Größe']);
      }
      return t('diamondPainting') + ' ' + splitCm(props.option['Größe']);
    case 'Quadratisch':
      if (props.type !== '8341420540169') {
        return t('paintByNumbers') + ' ' + splitCm(props.option['Größe']);
      }
      return t('diamondPainting') + ' ' + splitCm(props.option['Größe']);
    case ' Eigenes Bild  XXL / 3':
      if (props.type !== '8341420540169') {
        return t('paintByNumbers') + ' ' + t('triptych') + ' ' + splitCm(props.option['Größe']);
      }
      return t('diamondPainting') + ' ' + t('triptych') + ' ' + splitCm(props.option['Größe']);
    case ' Eigenes Bild XXL / 5':
      if (props.type !== '8341420540169') {
        return t('paintByNumbers') + ' ' + t('fivePart') + ' ' + splitCm(props.option['Größe']);
      }
      return t('diamondPainting') + ' ' + t('fivePart') + ' ' + splitCm(props.option['Größe']);
    default:
      return titel + ' ' + splitCm(props.option['Größe']);
  }

}

function generatePriceAll(groeße = false, option1 = false, option2 = false) {
  let varianten = data.value.variants;
  if (groeße && option1 && option2) {
    let variantsPrice = varianten.filter(function (variant) {

      if (variant.title == groeße + ' / ' + option1 + ' / ' + option2) {
        return variant.price;
      }
    })

    return variantsPrice;

  } else if (groeße && option1) {

    let variantsPrice = varianten.filter(function (variant) {

      if (variant.title == groeße + ' / ' + option1) {
        return variant.price;
      }
    })

    return variantsPrice;
  }
}

function changeToggle(index) {
  setTimeout(() => {
    let details = document.querySelectorAll("details");
    let navBar = document.querySelector(".navBar");
    let mainWrapper = document.querySelector(".mainWrapper");

    details.forEach(function (detail, loopIndex) {
      detail.classList.remove('hide');

      if (details[index].open) {
        navBar.classList.add('open');
        mainWrapper.classList.add('open');
      } else {
        navBar.classList.remove('open');
        mainWrapper.classList.remove('open');
      }
      if (index !== loopIndex && details[index].open) {
        detail.open = false;
        detail.classList.add('hide');
      }
    });
  }, "50");
}

function splitCm(value) {
  // Überprüfen, ob das Eingabeformat gültig ist

  if (!value) {
    return;
  }

  if (value.includes("cm") === false) {
    return value;
  }

  const match = value.match(/^(\d+)x(\d+)(\w+)$/);
  if (!match || match.length < 4) {
    return t('invalidFormat');
  }

  // Zerlegen der Teile und Erstellen des neuen Formats
  const width = match[1];
  const height = match[2];
  const unit = match[3];

  return `${width} x ${height}${unit}`;
}

function translateOptionName(name) {
  const names = {
    'Größe': t('size'),
    'Steinform': t('stoneShape'),
    'Rahmen': t('frame'),
    'Farbe': t('color'),
    'Size': t('size'),
    'Stone shape': t('stoneShape'),
    'Frame': t('frame'),
    'Color': t('color'),
    'color': t('color'),
    'frame': t('frame'),
    'size': t('size')
  };
  return names[name] || name;
}

function translateOptionValue(optionName, value) {
  if (optionName === 'Rahmen') {
    if (value === 'Ohne Keilrahmen (Nur Leinwand)') return t('frameWithout');
    if (value === 'Mit Keilrahmen (bereits bespannt)') return t('frameWith');
  }
  if (optionName === 'Farbe' || optionName === 'Color' || optionName === 'color') {
    if (value === 'max. 24 Farben' || value === 'max. 24 colors') return t('max24Colors');
    if (value === 'max. 36 Farben' || value === 'max. 36 colors') return t('max36Colors');
  }
  if (optionName === 'Steinform') {
    if (value === 'Rund') return t('stoneRound');
    if (value === 'Quadratisch') return t('stoneSquare');
  }
  return splitCm(value);
}

function displaySelected(optionName, value) {
  if (!value) return '';
  if (optionName === 'Rahmen') {
    return translateOptionValue(optionName, value);
  }
  if (optionName === 'Farbe' || optionName === 'Color' || optionName === 'color') {
    return translateOptionValue(optionName, value);
  }
  if (optionName === 'Steinform') {
    return translateOptionValue(optionName, value);
  }
  if (optionName === 'Größe') {
    return splitCm(value);
  }
  return value;
}

function setProductType(type) {
  instance.appContext.config.globalProperties.$producttype = type;
}

function getImageSizeToRoom(option) {
  if(!option || !option['Größe']) {
    return;
  }
  const imgSize = document.querySelector('.preview-area img.croppedImage')

  if(!imgSize) {
    return;
  }

  if (props.routeinfo.name === "produktansicht" || props.routeinfo.name === "vorschau") {
    imgSize.removeAttribute('width');
    imgSize.removeAttribute('height');
    return;
  }
  const roomSize = document.querySelector('img.bottom');
  if(!roomSize) {
    return;
  }
  const ration = option['Größe'].split('x');

  if(ration.length < 2) {
    return;
  }

  let imgSizeWidth = ((roomSize.naturalWidth - 180) / 200) * Number(ration[0]);
  let imgSizeHeight = ((roomSize.naturalWidth - 180) / 200) * Number(ration[1].slice(0, -2));

  if (imgSize.width > imgSize.height) {
    imgSizeHeight = ((roomSize.naturalWidth - 180) / 200) * Number(ration[0]);
    imgSizeWidth = ((roomSize.naturalWidth - 180) / 200) * Number(ration[1].slice(0, -2));
  }

  imgSize.width = imgSizeWidth;
  imgSize.height = imgSizeHeight;
}

function generatePercentAll(compare_price, price) {
  let allPercent = 0;
  allPercent = 100 - ((100 / compare_price) * price);
  allPercent = (allPercent).toFixed(0)

  if (isNaN(allPercent)) {
    return '';
  }
  return allPercent;
}

function isBlackWeekSKU(variantId) {
  return BlackWeekSKUs.includes(variantId.toString());
}

function formatPrice(value) {
  if (value === undefined || value === null || value === '') {
    return '';
  }
  return Number(value).toLocaleString(numberLocale.value);
}

</script>

<template>
  <section class="navBar" v-if="$route.name !== 'vorschau'">
    <input :value="$cropimage.value" ref="cropNew" style="display: none">
    <template v-if="step == 1">
      <div class="roundBox">
        <b>{{ getTitel(data.title) }}</b>
        <template
            v-if="data && (option['Größe'] && option['Steinform']) ||  (option['Größe'] && option['Rahmen'] && option['Farbe']) ">
          <p><span class="price">{{ price }}€</span> <span class="old_price">{{ compare_price }}€</span> <span
              class="percent">-{{ percent }}%</span></p>
          <p class="priceInfo">{{ t('priceInfo') }}</p>
          <button class="cta" @click="nextStep()">{{ t('next') }}</button>
        </template>
      </div>
      <div :class="'roundBox '+ productOptions.name" v-for="(productOptions, index) in data.options">
        <details :open='toggle[index]' @click='changeToggle(index)'>
          <summary v-if="productOptions.name == 'Größe'"><b>{{ t('sizeAndFormat') }}</b>
            {{ displaySelected(productOptions.name, option[productOptions.name]) }}
          </summary>
          <summary v-else><b>{{ translateOptionName(productOptions.name) }}</b> {{ displaySelected(productOptions.name, option[productOptions.name]) }}</summary>
          <ul v-if="datas && productOptions.name == 'Größe'">
            <li v-for="(type, index) in datas" class="productType" v-if="type"
                :class="{active: activeTab === type.title}"
                @click="data = datas[index], activeTab = type.title, option[productOptions.name] = data.options[0].values[0], setProductType(type.title), generatePrice(data,option)">
              {{ getProduktTitle(type.title) }}
            </li>
          </ul>
          <div class="dropDown">
            <div v-for="(value, index) in productOptions.values" class="option">
              <input v-model="option[productOptions.name]" type="radio" :name="productOptions.name" :id="value"
                     :value="value" :title="value" :checked="index===0 ? true: false"
                     @change="generatePrice(data,option)">
              <label :for="value"><p>{{ translateOptionValue(productOptions.name, value) }}
                <!-- BLACK DEAL by SKU -->
                <template v-if="productOptions.name === 'Größe' && generatePriceAll(value, option['Steinform'] || option['Rahmen'], option['Farbe'])?.[0]?.sku && isBlackWeekSKU(generatePriceAll(value, option['Steinform'] || option['Rahmen'], option['Farbe'])[0].sku)">
                  <span class="redBadge blackdeal" v-if="generatePriceAll(value, option['Steinform'] || option['Rahmen'], option['Farbe'])?.[0]?.sku && isBlackWeekSKU(generatePriceAll(value, option['Steinform'] || option['Rahmen'], option['Farbe'])[0].sku)">BLACK DEAL</span>
                  {{ console.log('Template: productOptions.name:', productOptions.name, 'value:', value, 'option values:', option) }}
                </template>

                <!-- CYBER DEAL -->
                <template v-else-if="(currentDate >= cyberDealStart && currentDate <= cyberDealEnd) && productOptions.name !== 'Steinform'">
                  <span class="yellowInfo cyber" v-if="index === (productOptions.values).length - 2 && props.type == 8341420540169">CYBER DEAL</span>
                  <span class="yellowInfo cyber" v-if="value == '50x75cm'">CYBER DEAL</span>
                  <span class="yellowInfo blackdeal" v-if="(value == '40x50cm' || value == '60x75cm')">CYBER DEAL</span>
                </template>

                <!-- Kein Angebot aktiv -->
                <template v-else>
                  <span class="yellowInfo" v-if="index === (productOptions.values).length - 2 && props.type == 8341420540169"> {{ t('bestResult') }}</span>
                  <span class="yellowInfo" v-if="value == '50x75cm'">{{ t('bestseller') }}</span>
                </template>

              </p>

                <div class="priceBox" v-if="productOptions.name == 'Größe' && props.type == 8341420540169"><span
                    class="red">{{

                    formatPrice(generatePriceAll(value, option['Steinform'])?.[0]?.price)
                  }} €</span> <br>
                  <span class="linethrough">{{
                      formatPrice(generatePriceAll(value, option['Steinform'])?.[0]?.compare_at_price)
                    }}€</span> <span
                      v-if="generatePercentAll(generatePriceAll(value, option['Steinform'])?.[0]?.compare_at_price,generatePriceAll(value, option['Steinform'])?.[0]?.price  )"
                      class="percent">{{
                      generatePercentAll(generatePriceAll(value, option['Steinform'])?.[0]?.compare_at_price, generatePriceAll(value, option['Steinform'])?.[0]?.price)
                    }} %</span>
                </div>
                <div class="priceBox" v-else-if="productOptions.name == 'Größe'"><span class="red">{{

                    formatPrice(generatePriceAll(value, option['Rahmen'], option['Farbe'])?.[0]?.price)
                  }} €</span> <br>
                  <span class="linethrough">{{
                      formatPrice(generatePriceAll(value, option['Rahmen'], option['Farbe'])?.[0]?.compare_at_price)
                    }}€</span> <span
                      v-if="generatePercentAll(generatePriceAll(value, option['Rahmen'], option['Farbe'])?.[0]?.compare_at_price,generatePriceAll(value, option['Rahmen'], option['Farbe'])?.[0]?.price  )"
                      class="percent">{{
                      generatePercentAll(generatePriceAll(value, option['Rahmen'], option['Farbe'])?.[0]?.compare_at_price, generatePriceAll(value, option['Rahmen'], option['Farbe'])?.[0]?.price)
                    }} %</span>
                </div>
              </label>
            </div>
          </div>
        </details>
      </div>
      <div v-if="props.type == 8341420540169 && $route.path !== '/vorschau'" class="roundBox center">
        <b @click="instance.appContext.config.globalProperties.vorschau = true">
          <RouterLink to="/vorschau">{{ t('previewLower') }}</RouterLink>
        </b>
      </div>
      <div v-if="$route.path === '/vorschau'" class="roundBox center">
        <b>
          <RouterLink to="/vorschau">{{ t('previewLower') }}</RouterLink>
        </b>
      </div>
      <button class="cta mobile" @click="nextStep()">{{ t('next') }}</button>
    </template>
    <Options @next-step="nextStep" @step-back="stepBack" @cart="cart" @cartandrestart="cartandrestart" :step="step"
             :product="product" :productsize="productSize" :type="props.type" :quantity="quantity"/>
    <!--    <ImagePreview :img="$cropimage.value" :showImagePreview="showImagePreview"/>-->
  </section>


</template>

<style scoped>

.roundBox span.yellowInfo {
  color: var(--c-text-orange);
  margin-left: 15px;
  font-size: 18px;
  background-image: linear-gradient(147deg, rgba(255, 125, 176, 1) 20%, rgba(255, 221, 90, 1) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 700;
}
.roundBox span.yellowInfo.cyber {
  background: #1993f4;
  color: #fff;
  -webkit-text-fill-color: #fff;
  border-radius: 50px;
  padding: 8px 25px;
  font-size: 11px;
}
.roundBox span.yellowInfo.blackdeal {
  background: #ee1cc6;
  color: #fff;
  -webkit-text-fill-color: #fff;
  border-radius: 50px;
  padding: 5px 10px;
  font-size: 9px;
}

.roundBox span.redBadge.blackdeal {
  background: #121212;
  color: #f45a5a;
  border-radius: 50px;
  padding: 5px 10px;
  font-size: 11px;
  font-weight: 700;
  margin-left: 15px;
}
.roundBox.Größe, .roundBox.Steinform, .roundBox.Farbe, .roundBox.Rahmen {
  cursor: pointer;
  font-size: 26px;
  padding: 0;
}
.roundBox summary {
  padding: 19pt 16pt 19pt 16pt;
}

body {
  background-color: #262626;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100svh;
  font-family: sans-serif;
  padding: 5rem;
}

ul {
  width: 100%;
  background: #ddd;
  position: absolute;
  top: calc(100% + .5rem);
  left: 0;
  padding: 1rem;
  margin: 0;
  box-sizing: border-box;
  border-radius: 5px;
  max-height: 200px;
  overflow-y: auto;
}

li {
  margin: 0;
  padding: 1rem 0;
  border-bottom: 1px solid #ccc;
}

li:first-child {
  padding-top: 0;
}

li:last-child {
  padding-bottom: 0;
  border-bottom: none;
}

ul.list {
  counter-reset: labels;
}

.price {
  color: #EF6461;
}

.old_price {
  color: #001761;
  text-decoration: line-through;
}

.percent {
  background: #EF6461;
  color: #fff;
  border-radius: 50px;
  padding: 1px 5px;
  font-size: 14px !important;
}

.roundBox.center {
  text-align: center;
  cursor: pointer;
  min-height: 90px;
}

.roundBox.center a {
  text-transform: capitalize;
  color: #001761;
  font-weight: 700;
  background: url("https://picmondo.de/projekte/generator/dist/assets/img/vorschau_icon.png") left 6px no-repeat;
  padding-left: 35px;
  background-size: 25px;
}

.roundBox ul {
  display: flex;
  width: 100%;
  position: unset;
  border-radius: 0;
  background: #fff;
  /*justify-content: space-between;*/
  border-bottom: 1px solid #CDCFC6;
  padding: 0 2rem;
}

.roundBox li.productType.active {
  font-weight: 700;
}

.roundBox li.productType {
  display: inline-block;
  list-style: none;
  font-size: 16px;
  text-align: center;
  color: #001761;
  border: none;
  padding: 0 0 0.8rem;
  position: relative;
}

.roundBox li.productType:nth-child(n+2) {
  margin-left: 15pt;
}

.roundBox li.productType:nth-child(n+3) {
  display: none;
}

.roundBox li.productType.active::after {
  content: '';
  background: var(--c-text-orange);
  height: 5px;
  width: 120%;
  position: absolute;
  bottom: 0;
  left: -10%;
  border-radius: 5px;
}

.roundBox b {
  font-size: 28px;
  font-weight: 700;
  color: #001761;
}

.roundBox summary {
  text-align: right;
}

.roundBox summary::after {
  content: '';
  background: url(https://picmondo.de/projekte/generator/dist/assets/img/angle.svg) center center no-repeat;
  width: 20px;
  height: 15px;
  display: inline-block;
  margin-left: 25px;
  transform: rotate(180deg);
}

.roundBox details[open] summary::after {
  transform: rotate(0deg);
}

.roundBox summary b {
  float: left;
  font-size: 23px;
}

summary {
  color: #001761;
  font-size: 23px;
}

summary::marker, summary::-webkit-details-marker {
  content: '';
  display: none;
}

.roundBox span {
  font-size: 22px;
  margin: 0 5px;
}

input[type="radio"] {
  display: grid;
  place-content: center;
}

input[type="radio"]::before {
  content: "";
  width: 15px;
  height: 15px;
  border-radius: 50%;
  transition: 120ms transform ease-in-out;
  background: #E8E4DD;
  transform: scale(1);
}

input[type="radio"]:checked::before {
  background: url('https://picmondo.de/projekte/generator/dist/assets/img/auswahlIcon.svg') center center;
  background-size: contain;
}

input[type="radio"]:checked + label p {
  font-weight: 700;
  max-width: 65%;
}

label {
  color: #001761;
  font-size: 16px;
  margin-left: 20px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

.option {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 5px 10pt;
  border-bottom: 1px solid #CDCFC6;
  height: 55pt;
}

.option span.red {
  color: #EF6461;
  float: right;
}

.option .priceBox .linethrough {
  color: #001761;
  text-decoration: line-through;
}

.priceBox span {
  font-size: 9.9pt;
}

.priceBox span.percent {
  font-size: 15px !important;
  font-size: 8.4pt !important;
  padding: 1px 7px;
}

.priceInfo {
  color: #cdcfc6;
  text-decoration: underline;
  font-size: 22px;
}
</style>
